import { Theme } from '@mui/material';

export const getWrapperStyles = (fullHeight?: boolean) => ({
	position: 'relative',
	height: fullHeight ? '100%' : 'auto',
});

export const getSwiperStyles = (fullheight?: boolean) => ({ height: fullheight ? '100%' : 'auto' });

export const badgeStyles = {
	position: 'absolute',
	left: {
		xs: '1.43rem',
		md: '2%',
	},
	top: {
		xs: '1.25rem',
		md: '2%',
	},
	zIndex: 9,
};

export const swiperActionsWrapper = (enableSliderControlsBackgroundGradient?: boolean) => ({
	width: '100%',
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	alignItems: 'center',
	position: 'absolute',
	zIndex: 9,
	gap: '0.25rem',
	height: '3.5rem',
	bottom: 0,
	...(enableSliderControlsBackgroundGradient && {
		background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0.00) 100%)',
	}),
});

export const manualRecordIconWrapper = {
	display: 'flex',
	flexDirection: 'row',
	gap: '0.75rem',
};

export const manualRecordIconStyles = (index: number, activeStep: number, theme: Theme) => {
	return {
		fontSize: '0.5rem',
		cursor: 'pointer',
		color: index === activeStep ? theme.palette.secondary.main : theme.palette.neutrals?.primary,
	};
};

export const buttonStyles = (theme: Theme) => ({
	color: theme.palette.secondary.main,
	'&.Mui-disabled': {
		color: theme.palette.neutrals?.primary,
	},
});
